
export const RouteGC: IDiaryRoute = {
  name: 'giftcards',
  url: '/giftcards'
}
export const RouteGCManagement: IDiaryRoute = {
  name: `${RouteGC.name}.management`,
  url: '/management',
  parentName: RouteGC.name
}


export interface IDiaryRoute {
  name: string;
  url: string;
  parentName?: string;
}
